export enum BOOKING_TYPE {
  ONGOING = 'ongoing',
  COMPLETED = 'completed',
}
